window.nostoInit = window.nostoInit || {};
const DOTS = "...";
(function () {
  "use strict";
  const FILTER_PREFIX   = 'd10_';
  const addM10  = (key) => `${FILTER_PREFIX}${key}`;
  const stripM10 = (key) => key.startsWith(FILTER_PREFIX) ? key.slice(FILTER_PREFIX.length) : key;
  nostoInit.initNostoCollection = function () {
    (async () => {
      // setTimeout(() => {
      //     if (!window.hasOwnProperty('nostojs')) {
      //         alert('There was a problem on the server, please reload the page and try again')
      //         location.reload();
      //     }
      // }, 5000);

      while (!window.hasOwnProperty("nostojs")) {
        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      loadPageWithApiResponse();
    })();

    function loadPageWithApiResponse() {
      let options = nostoInit.options,
          totalItemPerPage = options.per_row * options.rows_per_page,
          fromItem = 0,
          url = new URL(window.location.href),
          currentPage = url.searchParams.get("page")
              ? Number(url.searchParams.get("page"))
              : 1,
          sortBy = url.searchParams.get("sort_by") ?? "",
          sortFilter = "",
          bannerSetting = theme.banners_settings.collection_banner,
          filterParam = getFilter(),
          bannerId = document.getElementsByClassName(
              "nosto-collection-banner-id"
          ),
          endPoint = "https://search.nosto.com/v1/graphql",
          token = theme.nosto_credentials.access_token,
          accountId = theme.nosto_credentials.account_id,
          colorFiltered = url.searchParams.getAll("skus.customFields.colour");

      if (sortBy === "price-ascending") {
        sortFilter = `[{field: "price", order: asc}]`;
      } else if (sortBy === "price-descending") {
        sortFilter = `[{field: "price", order: desc}]`;
      } else if (sortBy === "title-ascending") {
        sortFilter = `[{field: "name", order: asc}]`;
      } else if (sortBy === "title-descending") {
        sortFilter = `[{field: "name", order: desc}]`;
      } else if (sortBy === "created-ascending") {
        sortFilter = `[{field: "datePublished", order: asc}]`;
      } else if (sortBy === "created-descending") {
        sortFilter = `[{field: "datePublished", order: desc}]`;
      }

      if (currentPage > 1) fromItem = totalItemPerPage * (currentPage - 1);

      window.collectionBannerHtml = ``;
      if (
          bannerId &&
          typeof bannerId[0] !== undefined &&
          bannerId[0].value !== ""
      ) {
        nostojs((api) => {
          api
              .createRecommendationRequest({})
              .setElements([bannerId[0].value])
              .load()
              .then((response) => {
                if (
                    typeof response.recommendations[bannerId[0].value] !== undefined
                ) {
                  window.collectionBannerHtml =
                      response.recommendations[bannerId[0].value];
                  if (
                      window.collectionBannerHtml &&
                      document.querySelector(".reservation-banner")
                  ) {
                    let listProductWrapper = document.querySelector(
                            "#NostoCollectionAjaxContent .product-list-collection"
                        ),
                        bannerReservations =
                            listProductWrapper.getElementsByClassName(
                                "reservation-banner"
                            );
                    let dataAppend = [];
                    for (let i = 0; i < bannerReservations.length; i++) {
                      var bannerContent = document.createElement("div");
                      bannerContent.innerHTML = window.collectionBannerHtml;
                      dataAppend.push({
                        insert: bannerContent.firstChild,
                        toBanner: bannerReservations[i],
                      });
                    }

                    for (let i = 0; i < dataAppend.length; i++) {
                      listProductWrapper.replaceChild(
                          dataAppend[i].insert,
                          dataAppend[i].toBanner
                      );
                    }

                    setHeightBanner();
                  }
                }
              });
        });
      }

      fetch(endPoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `query {
                          search(
                            accountId: "${accountId}"
                            products: {
                              categoryId: "${options.category}"
                              size: ${totalItemPerPage}
                              from: ${fromItem}
                              facets: ["*"]
                              ${
              filterParam.length
                  ? "filter:[{all:[" + filterParam + "]}]"
                  : ""
          }
                              ${sortFilter.length ? "sort:" + sortFilter : ""}
                            }
                          ) {
                            products {
                              hits {
                                url
                                productId
                                name
                                imageUrl
                                priceCurrencyCode
                                availability
                                price
                                listPrice
                                brand
                                datePublished
                                tags1
                                customFields {
                                  key
                                  value
                                }
                                skus {
                                  name
                                  imageUrl
                                  id
                                  price
                                  customFields {
                                    key
                                    value
                                  }
                                }
                              }
                              facets {
                                ... on SearchTermsFacet {
                                  id
                                  field
                                  type
                                  name
                                  data {
                                    value
                                    count
                                    selected
                                  }
                                }
                                ... on SearchStatsFacet {
                                  id
                                  field
                                  type
                                  name
                                  min
                                  max
                                }
                              }
                              total
                              size
                              from
                              fuzzy
                            }
                            redirect
                            keywords {
                              hits {
                                keyword
                              }
                            }
                          }
                        }`,
        }),
      })
          .then((res) => res.json())
          .then((response) => {
            if (response.errors !== undefined) {
              let shopifyCollectionSelector = document.querySelector(
                  '.collection-content[data-shopify-collection="true"]'
              );
              document.querySelector(".loading").style.display = "none";
              shopifyCollectionSelector.style.display = "block";
              shopifyCollectionSelector.querySelector(
                  ".grid .grid--uniform"
              ).style.display = "block";
            }
            if (response.data.search.products) {
              // if (response.data.search.products.total > 0 && response.data.search.products.size == 0) {
              //   document.querySelector('.loading').style.display = 'none';
              //   let productList = document.getElementById('NostoCollectionAjaxContent'),
              //       productListTemplate = document.getElementById('NostoCollectionAjaxContentTemplate');
              //   document.getElementsByClassName('js-drawer-open-collection-filters')[0].style.display = 'none';
              //   document.getElementsByClassName('collection-filter__item--sort')[0].style.display = 'none';
              //   productList.innerHTML = '';
              //   productList.innerHTML = productListTemplate.innerHTML.replace('%collection-count%', '0 product')
              //   productList.style.display = 'block';
              //   return;
              // }
              let productList = document.getElementById(
                      "NostoCollectionAjaxContent"
                  ),
                  productListTemplate = document.getElementById(
                      "NostoCollectionAjaxContentTemplate"
                  ),
                  productTemplate = document.getElementById(
                      "NostoProductAjaxContent"
                  ),
                  productPager = document
                      .getElementById("NostoProductPager")
                      .cloneNode(true),
                  rate = Shopify.currency.rate,
                  currencyCode = Shopify.currency.active,
                  formatter = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "narrowSymbol",
                  }),
                  locationType = "SidebarDrawer",
                  tagFilterActive = getTagActive(),
                  queryParams = new URLSearchParams(window.location.search);

              productList.innerHTML = "";
              if (response.data.search.products.hits.length === 1)
                productList.innerHTML = productListTemplate.innerHTML.replaceAll(
                    "%collection-count%",
                    response.data.search.products.total + " product"
                );
              productList.innerHTML = productListTemplate.innerHTML.replace(
                  "%collection-count%",
                  response.data.search.products.total + " products"
              );

              let countForBanner = 0,
                  positionBanner = bannerSetting.position;
              for (const product of response.data.search.products.hits) {
                //banner render
                countForBanner++;
                if (bannerSetting.enable) {
                  if (
                      (bannerSetting.repeat &&
                          countForBanner % positionBanner === 0) ||
                      (!bannerSetting.repeat && countForBanner === positionBanner)
                  ) {
                    let bannerHtml = window.collectionBannerHtml
                        ? window.collectionBannerHtml
                        : '<span class="reservation-banner" style="display:none"></span>';
                    productList
                        .getElementsByClassName("product-list-collection")[0]
                        .insertAdjacentHTML("beforeend", bannerHtml);

                    countForBanner++;
                  }
                }

                let productVariants = matchVariantsData(product, colorFiltered);

                //price process
                let productPriceContent = formatter.format(
                        Number(product.price) * rate
                    ),
                    productLabelContent = "";
                if (product.price !== product.listPrice) {
                  let showSaveAmout = options.product_save_amount,
                      showSaveType = options.product_save_type,
                      finalPrice = formatter.format(Number(product.price) * rate),
                      basePrice = formatter.format(
                          Number(product.listPrice) * rate
                      ),
                      finalPriceHtml = "<span>" + finalPrice + "</span>";
                  if (product.skus) {
                    let basePrice = product.price,
                        showPriceFrom = false;
                    product.skus.forEach((item) => {
                      if (item.price !== basePrice) showPriceFrom = true;
                      if (item.price < basePrice) basePrice = item.price;
                    });

                    if (showPriceFrom) {
                      finalPriceHtml =
                          " from " + "<span>" + finalPrice + "</span>";
                    }
                  }
                  productPriceContent =
                      '<span class="grid-product__price--original">RRP ' +
                      basePrice +
                      "</span>" +
                      finalPriceHtml;
                  if (showSaveAmout) {
                    if (showSaveType === "dollar") {
                      let saveValue = formatter.format(
                          (Number(product.listPrice) - Number(product.price)) * rate
                      );
                      productPriceContent +=
                          '<span class="grid-product__price--savings"> ' +
                          saveValue +
                          " OFF</span>";
                    } else {
                      let saveValue =
                          ((Number(product.listPrice) - Number(product.price)) /
                              basePrice) *
                          100;
                      productPriceContent +=
                          '<span class="grid-product__price--savings">' +
                          saveValue +
                          " OFF</span>";
                    }
                  }
                  if (product.availability === "InStock")
                    productLabelContent =
                        '<div class="grid-product__tag grid-product__tag--sale">Sale</div>';
                } else {
                  if (product.skus) {
                    let basePrice = product.price,
                        showPriceFrom = false;
                    product.skus.forEach((item) => {
                      if (item.price !== basePrice) showPriceFrom = true;
                      if (item.price < basePrice) basePrice = item.price;
                    });

                    if (showPriceFrom) {
                      productPriceContent =
                          "from " + formatter.format(Number(basePrice) * rate);
                    }
                  }
                }

                if (product.availability === "OutOfStock")
                  productLabelContent =
                      '<div class="grid-product__tag grid-product__tag--sold-out">Sold Out</div>';
                if (product.tags1) {
                  let isClearance = false;
                  let isAustralianMade = false;

                  // First check for clearance and Australian made
                  for (const tags of product.tags1) {
                    const lowerTag = tags.toLowerCase();
                    if (lowerTag.includes("clearance")) {
                      isClearance = true;
                      break;
                    }
                    if (lowerTag.includes("australian made")) {
                      isAustralianMade = true;
                      break;
                    }
                  }

                  // Set content based on priority
                  if (isClearance) {
                    productLabelContent = `<div class="grid-product__tag grid-product__tag--clearance">CLEARANCE</div>`;
                  } else if (isAustralianMade) {
                    productLabelContent = `<div class="grid-product__tag grid-product__tag--australian-made">AUSTRALIAN MADE</div>`;
                  } else {
                    // Check for custom label as fallback
                    for (const tags of product.tags1) {
                      if (tags.includes("_label_")) {
                        let custom_label = tags
                            .replace("_label_", "")
                            .toUpperCase();
                        productLabelContent = `<div class="grid-product__tag grid-product__tag--custom">${custom_label}</div>`;
                      }
                    }
                  }
                }

                if (product.customFields) {
                  product.customFields.forEach((item) => {
                    if (
                        item.key === "custom-show_product_price" &&
                        item.value === "true"
                    ) {
                      productPriceContent = "";
                    }
                  });
                }
                //build product image
                let productImageContent = document.createElement("img");
                productImageContent.src = productVariants.imageUrl;
                productImageContent.className =
                    "grid__image-contain image-style--image-element";
                productImageContent.alt = product.name;
                let productContent = productTemplate.innerHTML
                    .replaceAll("%product-id%", product.productId)
                    .replaceAll("%product-image%", productImageContent.outerHTML)
                    .replaceAll("#", productVariants.url)
                    .replaceAll("%product-name%", product.name)
                    .replaceAll("%product-vendor%", product.brand)
                    .replaceAll("%product-price%", productPriceContent)
                    .replaceAll("%product-handle%", product.url.split("/").pop())
                    .replaceAll("%product-label%", productLabelContent);
                productList
                    .getElementsByClassName("product-list-collection")[0]
                    .insertAdjacentHTML("beforeend", productContent);
              }
              //create pager
              let numPages = Math.ceil(
                  response.data.search.products.total / totalItemPerPage
              );
              if (numPages > 1) {
                if (currentPage === 1) {
                  productPager.getElementsByClassName("prev")[0].style.display =
                      "none";
                } else if (currentPage === numPages) {
                  productPager.getElementsByClassName("next")[0].style.display =
                      "none";
                }
                let prevPage = Number(currentPage) - 1,
                    nextPage = Number(currentPage) + 1;
                queryParams.set("page", prevPage);
                productPager
                    .getElementsByClassName("prev")[0]
                    .getElementsByTagName("a")[0].href =
                    "//" +
                    location.host +
                    location.pathname +
                    "?" +
                    queryParams.toString();
                queryParams.set("page", nextPage);
                productPager
                    .getElementsByClassName("next")[0]
                    .getElementsByTagName("a")[0].href =
                    "//" +
                    location.host +
                    location.pathname +
                    "?" +
                    queryParams.toString();

                let pagerHtml = getPaginationHtml(2, currentPage, numPages);
                let pagination =
                    productPager.getElementsByClassName("pagination")[0];

                pagerHtml.forEach((item) => {
                  if (item !== currentPage && item !== DOTS) {
                    let pager = document.createElement("span"),
                        queryParams = new URLSearchParams(window.location.search);
                    pager.className = "page";
                    let link = document.createElement("a");
                    queryParams.set("page", item);
                    link.href =
                        "//" +
                        location.host +
                        location.pathname +
                        "?" +
                        queryParams.toString();
                    link.textContent = item;
                    pager.appendChild(link);
                    pagination.insertBefore(
                        pager,
                        pagination.getElementsByClassName("next")[0]
                    );
                  } else if (item === DOTS) {
                    let pager = document.createElement("span");
                    pager.textContent = item;
                    pagination.insertBefore(
                        pager,
                        pagination.getElementsByClassName("next")[0]
                    );
                  } else {
                    let pager = document.createElement("span");
                    pager.className = "page current";
                    pager.textContent = item;
                    pagination.insertBefore(
                        pager,
                        pagination.getElementsByClassName("next")[0]
                    );
                  }
                });
                productList.insertAdjacentHTML(
                    "beforeend",
                    productPager.innerHTML
                );
                //create pager link
              }

              // start build Filter drawer content
              let filterForm = document.getElementsByClassName("filter-form")[0],
                  openCollaps = openFilterCollapsive(queryParams),
                  filterHtml = ``,
                  i = 1;

              for (const facet of response.data.search.products.facets) {
                let openCollapse = openCollaps.includes(facet.field);
                if (facet.field === "price") {
                  let priceRageFormatter = new Intl.NumberFormat("en-US", {
                        style: "decimal",
                        currency: currencyCode,
                        useGrouping: false,
                      }),
                      maxRange = priceRageFormatter.format(
                          Number(facet.max) * rate
                      ),
                      minRange = priceRageFormatter.format(
                          Number(facet.min) * rate
                      ),
                      minValue = queryParams.get(addM10("price.gte")),
                      maxValue = queryParams.get(addM10("price.lte")),
                      filterParam = getFilter();

                  if (filterParam.length === 0) {
                    let collectionPriceRage = JSON.parse(
                            window.localStorage.getItem("nosto-collection-price-rage")
                        ),
                        collectionId = options.category
                            .toLowerCase()
                            .split(" ")
                            .join("-");
                    if (collectionPriceRage === null) collectionPriceRage = {};

                    collectionPriceRage[collectionId] = {
                      maxRange: maxRange,
                      minRange: minRange,
                    };
                    window.localStorage.setItem(
                        "nosto-collection-price-rage",
                        JSON.stringify(collectionPriceRage)
                    );
                  } else if (
                      window.localStorage.getItem("nosto-collection-price-rage")
                  ) {
                    let collectionPriceRage = JSON.parse(
                            window.localStorage.getItem("nosto-collection-price-rage")
                        ),
                        collectionId = options.category
                            .toLowerCase()
                            .split(" ")
                            .join("-");
                    if (collectionPriceRage[collectionId] !== undefined) {
                      maxRange = collectionPriceRage[collectionId].maxRange;
                      minRange = collectionPriceRage[collectionId].minRange;
                    }
                  }

                  if (facet.max !== facet.min) {
                    filterHtml += `<div class="collection-sidebar__group--${i}">
                                <div class="collection-sidebar__group">
                                <button type="button" class="collapsible-trigger collapsible-trigger-btn collapsible--auto-height tag-list__header ${
                        openCollapse ? "is-open" : ""
                    }" aria-controls="${locationType}-${i}-filter-price" data-collapsible-id="filter-price" aria-expanded="true">Price
                                    <span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
                                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16">
                                            <path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path>
                                        </svg>
                                    </span>
                                </button>
                                <div id="${locationType}-${i}-filter-price" class="collapsible-content collapsible-content--sidebar ${
                        openCollapse ? "is-open" : ""
                    }" data-collapsible-id="filter-price" style="${
                        openCollapse ? "height: auto" : ""
                    }">
                                    <div class="collapsible-content__inner">
                                        <div class="price-range" data-min-value="${
                        minValue ?? minRange
                    }" data-min-name="filter.v.price.gte" data-min="${minRange}" data-max-value="${
                        maxValue ?? maxRange
                    }" data-max-name="filter.v.price.lte" data-max="${maxRange}">
                                            <div class="price-range__display-wrapper">
                                                <span class="price-range__display-min">${
                        minValue ?? minRange
                    }</span>
                                                <span class="price-range__display-max">${
                        maxValue ?? maxRange
                    }</span>
                                            </div>
                                             <div class="price-range__slider-wrapper">
                                                <div class="price-range__slider noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr">
                                                </div>
                                            </div>
                                            <input class="price-range__input price-range__input-min" name="filter.v.price.gte" value="${minRange}" readonly="">
                                            <input class="price-range__input price-range__input-max" name="filter.v.price.lte" value="${maxRange}" readonly="">
                                        </div></div>
                                </div>
                            </div>
                        </div>`;
                  }
                } else {
                  let isColour = facet.name === "Colour",
                      isStar =
                          facet.field ===
                          "skus.customFields.water_efficiency-star_rating",
                      inputHtml = "";
                  filterHtml += `<div class="collection-sidebar__group--${i}">
                            <div class="collection-sidebar__group">
                                <button type="button"
                                        class="collapsible-trigger collapsible-trigger-btn collapsible--auto-height tag-list__header ${
                      openCollapse ? "is-open" : ""
                  }"
                                        aria-controls="${locationType}-${i}-filter-${
                      facet.field
                  }"
                                        data-collapsible-id="filter-${
                      facet.field
                  }" aria-expanded="${
                      openCollapse ? "true" : "false"
                  }"> ${facet.name}
                                    <span class="collapsible-trigger__icon collapsible-trigger__icon--open"
                                          role="presentation">
                                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16">
                                              <path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path>
                                          </svg>
                                    </span>
                                </button>
                                <div id="${locationType}-${i}-filter-${
                      facet.field
                  }"
                                     class="collapsible-content collapsible-content--sidebar ${
                      openCollapse ? "is-open" : ""
                  }""
                                     data-collapsible-id="filter-${
                      facet.field
                  }" style="${
                      openCollapse ? "height: auto" : ""
                  }">
                                    <div class="collapsible-content__inner">
                                        <ul class="no-bullets tag-list">`;
                  facet.data.forEach(function (facetOption) {
                    let active = false;
                    if (
                        tagFilterActive.includes(
                            facet.field + "=" + facetOption.value
                        )
                    )
                      active = true;

                    tagFilterActive.forEach((item) => {
                      if (
                          item.includes(facet.field) &&
                          item.includes("=" + facetOption.value)
                      ) {
                        active = true;
                      }
                    });
                    if (isColour) {
                      let displayColour = facetOption.value.split(" ").pop(),
                          displayColourImage =
                              facetOption.value.toLowerCase().replaceAll(" ", "-") +
                              "." +
                              "webp",
                          displayColourImageUrl =
                              options.image_path + displayColourImage;

                      function checkExists(imageUrl, callback) {
                        var img = new Image();
                        img.onerror = function () {
                          callback(false);
                        };
                        img.onload = function () {
                          callback(true);
                        };
                        img.src = imageUrl;
                      }

                      checkExists(displayColourImageUrl, function (e) {
                        if (!e) {
                          displayColourImageUrl = "";
                          inputHtml = "";
                        }
                      });
                      //
                      inputHtml = `<span class="color-swatch color-swatch--filter color-swatch--${facetOption.value}" style="background-color:${displayColour} ; background-image: url(${displayColourImageUrl})"">${facetOption.value}</span>
                                                    <span class="tag__text">${facetOption.value}</span>`;
                    } else {
                      inputHtml = `<span class="tag__checkbox"></span>
                                                    <span><span class="tag__text">${facetOption.value}</span> (${facetOption.count})</span>`;
                    }
                    if (isStar) {
                      let valObj = JSON.parse(facetOption.value),
                          valFormated = `${valObj.scale_min}-${valObj.scale_max}-${valObj.value}`;

                      if (
                          tagFilterActive.includes(facet.field + "=" + valFormated)
                      )
                        active = true;

                      inputHtml = `<span class="tag__checkbox"></span>
                                                      <span><span class="tag__text">${valObj.value}</span> (${facetOption.count})</span>`;

                      filterHtml +=
                          `<li class="tag ${active ? "tag--active" : ""} ${
                              isColour ? "tag--swatch tag--show-label" : ""
                          }">
                                                <label id="tag-${valFormated}" class="tag__checkbox-wrapper text-label">
                                                    <input for="tag-${valFormated}" type="checkbox" class="tag__input"  f-nosto-group="${
                              facet.field
                          }" f-nosto-item="${valFormated}"
                                                           name="filter.v.${valFormated}" value="${valFormated}" ${
                              active ? "checked" : ""
                          }>
                                                    ` +
                          inputHtml +
                          `
                                                </label>
                                            </li>`;
                    } else {
                      filterHtml +=
                          `<li class="tag ${active ? "tag--active" : ""} ${
                              isColour ? "tag--swatch tag--show-label" : ""
                          }">
                                                <label id="tag-${
                              facetOption.value
                          }" class="tag__checkbox-wrapper text-label">
                                                    <input for="tag-${
                              facetOption.value
                          }" type="checkbox" class="tag__input"  f-nosto-group="${
                              facet.field
                          }" f-nosto-item="${facetOption.value}"
                                                           name="filter.v.${
                              facetOption.value
                          }" value="${
                              facetOption.value
                          }" ${active ? "checked" : ""}>
                                                    ` +
                          inputHtml +
                          `
                                                </label>
                                            </li>`;
                    }
                  });
                  filterHtml += `</ul>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                }
                i++;
              }
              filterForm.insertAdjacentHTML("beforeend", filterHtml);
              document.querySelector(".loading").style.display = "none";
              // end build Filter
              productList.style.display = "block";
              //
              setHeightBanner();

              theme.initNostoQuickShop();
              initSort();
              initFilter();
              initPriceRange();
              initDrawers();
              renderActiveTag();

              productList.style.display = "block";
              document.querySelector(".loading").style.display = "none";
              document.documentElement.classList.remove("js-drawer-open");
              document.querySelector("#NostoReservation").style.display = "none";

              // trigger product click
              let productElements = document.querySelectorAll(
                  ".nosto-product-item"
              );

              productElements.forEach((el) =>
                  el.addEventListener("click", (e) => {
                    nostojs((api) => {
                      api.recordSearchClick("category", {
                        productId: e.currentTarget.getAttribute("product-nosto-id"),
                        url: e.currentTarget.getAttribute("href"),
                      });
                    });
                  })
              );
            }
          });
    }

    // get variant data if match with query text search
    function matchVariantsData(product, colorFiltered) {
      let variantData = {};
      if (product.skus && colorFiltered.length) {
        product.skus.forEach(function (sku, index) {
          let listText = colorFiltered;

          let skuMapped = false;
          if (listText.length > 0) {
            listText.forEach(function (sWord) {
              if (
                  sku.name &&
                  sku.name.toLowerCase().includes(sWord.toLowerCase())
              ) {
                skuMapped = true;
              }
            });
          }

          if (skuMapped) {
            if (product.url.indexOf("?") > -1) {
              variantData.url =
                  product.url.replace(/\/$/, "") + "&variant=" + sku.id;
            } else {
              variantData.url = product.url + "?variant=" + sku.id;
            }

            variantData.imageUrl = sku.imageUrl;
            variantData.price = sku.price;
          }
        });
      }

      if (variantData.url) {
        let imageUrl = variantData.imageUrl
            ? variantData.imageUrl
            : product.imageUrl;
        return {
          url: variantData.url,
          imageUrl: imageUrl,
          price: variantData.price,
        };
      }

      return {
        url: product.url,
        imageUrl: product.imageUrl,
        price: product.price,
      };
    }

    function getPaginationHtml(siblingCount = 1, currentPage, totalPageCount) {
      const totalPageNumbers = siblingCount + 5;
      if (totalPageNumbers >= totalPageCount) {
        return range(1, totalPageCount);
      }
      const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
      const rightSiblingIndex = Math.min(
          currentPage + siblingCount,
          totalPageCount
      );
      const shouldShowLeftDots = leftSiblingIndex > 2;
      const shouldShowRightDots = rightSiblingIndex < totalPageCount - 1;

      const firstPageIndex = 1;
      const lastPageIndex = totalPageCount;
      if (!shouldShowLeftDots && shouldShowRightDots) {
        let leftItemCount = currentPage + siblingCount;
        let leftRange = range(1, leftItemCount);
        return [...leftRange, DOTS, totalPageCount];
      }

      if (shouldShowLeftDots && !shouldShowRightDots) {
        let rightRange = range(currentPage - siblingCount, totalPageCount);
        return [firstPageIndex, DOTS, ...rightRange];
      }
      if (shouldShowLeftDots && shouldShowRightDots) {
        let middleRange = range(leftSiblingIndex, rightSiblingIndex);
        return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
      }
    }

    function range(start, end) {
      let length = end - start + 1;
      return Array.from({ length }, (_, idx) => idx + start);
    }

    function initDrawers() {
      theme.FilterDrawer = new theme.Drawers(
          "FilterDrawer",
          "collection-filters",
          true
      );
      theme.collapsibles.init(document.getElementById("FilterDrawer"));
    }

    function initPriceRange() {
      const priceRangeEls = document.querySelectorAll(".price-range");
      priceRangeEls.forEach(
          (el) => new theme.PriceRange(el, { onChange: onChangePriceFilter })
      );
      let priceRangeMinFilter = document.querySelector(
          ".price-range__input-min"
      );
      if (priceRangeMinFilter) {
        priceRangeMinFilter.addEventListener(
            "priceChangeEvent",
            function (data) {
              urlUpdate([data.detail.min, data.detail.max], "price", "add", true);
            }
        );
      }
    }

    function onChangePriceFilter(e, z) {
      let min = this.sliderEl
              .querySelector(".noUi-origin .noUi-handle-lower")
              .getAttribute("aria-valuenow"),
          max = this.sliderEl
              .querySelector(".noUi-origin .noUi-handle-upper")
              .getAttribute("aria-valuenow");

      let events = new CustomEvent("priceChangeEvent", {
        detail: { min: min, max: max },
      });

      this.inputMinEl.dispatchEvent(events);
    }

    function openFilterCollapsive(queryParams) {
      let collapses = [],
          ignoreParams = ["q", "options[prefix]", "sort_by", "page"];

      queryParams.forEach((i, g) => {
        if (ignoreParams.includes(g)) return;

        if (["price.lte", "price.gte"].includes(g)) {
          collapses.push("price");
          return;
        }

        collapses.push(g);
      });

      return collapses;
    }

    function initSort() {
      let sortSelect = document.querySelector("#SortBy"),
          defaultSort = sortSelect.getAttribute("data-default-sortby"),
          url = new URL(window.location.href),
          currentSort = url.searchParams.get("sort_by") ?? "";
      if (currentSort !== "") sortSelect.value = currentSort;
      sortSelect.on("change", function () {
        let queryParams = new URLSearchParams(window.location.search);
        queryParams.set("sort_by", sortSelect.value || defaultSort);
        queryParams.delete("page"); // Delete if it exists
        window.location.search = queryParams.toString();
      });
    }

    function clickFilterItem(e) {
      let urlParams = new URLSearchParams(window.location.search),
          filterItem = e.target.getAttribute("f-nosto-item"),
          filterGroup = e.target.getAttribute("f-nosto-group"),
          removeItem = false,
          currentGroup = [];

      if (filterItem && filterGroup) {
        if ((currentGroup = urlParams.getAll(filterGroup))) {
          currentGroup.forEach((val) => {
            if (val === filterItem) removeItem = true;
          });
        }

        if (removeItem) {
          urlUpdate(filterItem, filterGroup, "remove");
        } else {
          urlUpdate(filterItem, filterGroup, "add");
        }
      }
    }

    function initFilter() {
      let filterInputs = document.getElementsByClassName("tag__input");
      for (let filterInput of filterInputs) {
        filterInput.addEventListener("change", clickFilterItem);
      }
    }

    function getTagActive() {
      let searchParams = new URLSearchParams(window.location.search),
          params = [],
          defaultIgnoreFilters = [
            "q",
            "options",
            "sort_by",
            "page",
            "_pos",
            "_psq",
            "_ss",
            "_v",
            "fbclid",
            "srsltid",
          ];

      let extraIgnore = theme.nosto_ingore_filters_extra.split(","),
          ignoreParams = theme.nosto_ingore_filters_extra
              ? [...defaultIgnoreFilters, ...extraIgnore]
              : defaultIgnoreFilters;

      ignoreParams = ignoreParams.map((i) => i.trim());

      searchParams.forEach((i, g) => {
        if (!g.startsWith(FILTER_PREFIX)) return;
        if (ignoreParams.includes(g)) return;
        params.push(g + "=" + i);
      });

      return params;
    }

    function getFilter() {
      let searchParams = new URLSearchParams(window.location.search),
          parameters = "",
          elementTracker = [],
          searchValue = [],
          priceFilter = [];

      searchParams.forEach(function (val, paramKey) {

        if (!paramKey.startsWith(FILTER_PREFIX)) return;
        paramKey = stripM10(paramKey)
        let value = val;

        // check star
        if (paramKey === "skus.customFields.water_efficiency-star_rating") {
          let varArr = val.split("-");
          value = `{"scale_min":"${varArr[0]}","scale_max":"${varArr[1]}","value":"${varArr[2]}"}`;
        }
        //
        if (!searchValue[paramKey]) {
          searchValue[paramKey] = [];
          searchValue[paramKey].push(value);
        } else {
          searchValue[paramKey].push(value);
        }
      });
      let defaultIgnoreFilters = [
            "q",
            "options[prefix]",
            "sort_by",
            "page",
            "_pos",
            "_psq",
            "_ss",
            "_v",
            "fbclid",
            "srsltid",
          ],
          extraIgnore = theme.nosto_ingore_filters_extra.split(","),
          ignoreFilters = theme.nosto_ingore_filters_extra
              ? [...defaultIgnoreFilters, ...extraIgnore]
              : defaultIgnoreFilters;

      ignoreFilters = ignoreFilters.map((i) => i.trim());
      ignoreFilters = ignoreFilters.flatMap(k => [k, addM10(k)]);
      searchParams.forEach(function (val, paramKey) {
        if (!paramKey.startsWith(FILTER_PREFIX)) return;
        paramKey = stripM10(paramKey);
        // if (elementTracker[paramKey] || paramKey === 'q' || paramKey === 'sort_by' || paramKey === 'page') return;
        if (elementTracker[paramKey]) return;
        if (ignoreFilters.includes(paramKey)) return;
        if (["price.gte", "price.lte"].includes(paramKey)) {
          priceFilter[paramKey] = val;
          return;
        }

        elementTracker[paramKey] = true;
        parameters += `{field: "${paramKey}",value: ${JSON.stringify(
            searchValue[paramKey]
        )}}`;
      });

      if (priceFilter["price.gte"]) {
        let priceRageFormatter = new Intl.NumberFormat("en-US", {
              style: "decimal",
              currency: "AUD",
              useGrouping: false,
            }),
            rate = Shopify.currency.rate,
            priceGt = priceRageFormatter.format(
                Number(priceFilter["price.gte"] / rate) - 0.1
            ),
            priceLte = priceRageFormatter.format(
                Number(priceFilter["price.lte"] / rate) + 0.1
            );

        parameters += `{field: "price", range: [{gt: "${priceGt}" lt: "${priceLte}"}]}`;
      }

      return parameters;
    }

    function urlUpdate(
        filterItem,
        filterGroup = null,
        action = null,
        priceType = false
    ) {
      if (action === null) action = "add";
      let url = new URL(window.location.href),
          parameter = null;
      url.searchParams.delete("page");
      let searchParamsSize = Number(url.searchParams.size);
      if (priceType) {
        let minPrice = filterItem[0],
            maxPrice = filterItem[1];
        url.searchParams.delete(addM10("price.gte"));
        url.searchParams.delete(addM10("price.lte"));
        searchParamsSize = Number(url.searchParams.size);
        if (searchParamsSize === 0) {
          parameter = "?";
        } else {
          parameter = url.search + "&";
        }
        parameter += addM10("price.gte") + "=" + minPrice + "&" + addM10("price.lte") + "=" + maxPrice;
      } else {
        if (action === "add") {
          if (searchParamsSize === 0) {
            parameter = "?";
          } else {
            parameter = url.search + "&";
          }
          parameter += addM10(filterGroup) + "=" + filterItem;
        }

        if (action === "remove") {
          if (filterItem === "price") {
            url.searchParams.delete(addM10("price.gte"));
            url.searchParams.delete(addM10("price.lte"));
            searchParamsSize = Number(url.searchParams.size);
            parameter = url.search;
          } else {
            url.searchParams.delete(filterGroup, filterItem);
            searchParamsSize = Number(url.searchParams.size);
            parameter = url.search;
          }
        }
      }
      if (searchParamsSize === 0)
        window.history.replaceState(null, null, location.pathname);
      window.history.replaceState(null, null, parameter);
      loadPageWithApiResponse();
    }

    function renderActiveTag() {
      let activeFilter = getTagActive(),
          htmlFilter = ``,
          renderedPrice = 0;
      activeFilter.forEach((item) => {
        let tag = item.split("="),
            titleTag = tag[1],
            dataGroup = tag[0],
            dataValue = tag[1];

        if (tag[0] === "skus.customFields.water_efficiency-star_rating") {
          let valArr = tag[1].split("-");
          titleTag = valArr[valArr.length - 1] + " star";
        }
        if (tag[0] === "price.gte" || tag[0] === "price.lte") {
          if (renderedPrice === 1) return;
          renderedPrice = 1;
          titleTag = "price";
          dataGroup = "price";
          dataValue = "price";
        }

        htmlFilter += `<li class="tag tag--remove">
          <a class="btn btn--small" data-group="${dataGroup}" data-value="${dataValue}">${titleTag}</a>
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path>
          </svg>
          </li>`;
      });
      document.querySelector(".tag-list--active-tags").innerHTML = htmlFilter;
      let tagRemoveItems = document.getElementsByClassName("tag--remove");
      for (let tagRemoveItem of tagRemoveItems) {
        tagRemoveItem.addEventListener("click", function (e) {
          urlUpdate(
              e.target.getAttribute("data-value"),
              e.target.getAttribute("data-group"),
              "remove"
          );
        });
      }

      let lengthActiveTags = tagRemoveItems.length;
      if (lengthActiveTags) {
        let filterButton = document.getElementsByClassName(
            "js-drawer-open-collection-filters"
        )[0];
        filterButton.classList.add("btn--tertiary-active");
        let iconFilter = filterButton.querySelector(".icon-filter");
        if (iconFilter) {
          iconFilter.remove();
          filterButton.textContent = "";
        }
        filterButton.insertAdjacentHTML(
            "beforeend",
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><title>icon-filter</title><path d="M48 42h10m-10 0a5 5 0 1 1-5-5 5 5 0 0 1 5 5ZM7 42h31M16 22H6m10 0a5 5 0 1 1 5 5 5 5 0 0 1-5-5Zm41 0H26"></path></svg> Filter (' +
            lengthActiveTags +
            ")"
        );
      }
    }

    function setHeightBanner() {
      let productHeight =
          document.getElementsByClassName("grid-product").length != 0
              ? document.getElementsByClassName("grid-product")[0].offsetHeight
              : "420";

      let elementNearestBanner = document.querySelectorAll(
          ".collection-content .nosto_element"
      );
      for (let banner of elementNearestBanner) {
        let nextHeight = banner.nextElementSibling
            ? banner.nextElementSibling.offsetHeight
            : "420";

        const bannerBlock = banner.getElementsByClassName("UNX-banner-block")[0];
        if (bannerBlock) {
          bannerBlock.style.height = nextHeight + "px";
        }
      }
    }
  };
})();
